"use client";

import { ReactNode } from "react";
import styles from "./PulseCircle.module.css";

type Props = {
  children: ReactNode;
  onClick?: () => void;
  label?: string;
  className?: string;
  coreClassName?: string;
  isQuiet?: boolean;
};

export default function PulseCircle(props: Props) {
  const { children, onClick, label, className, coreClassName, isQuiet } = props;
  const coreClasses = `${styles.core} ${coreClassName || ""}`;

  return (
    <span className={`${styles.container} ${isQuiet ? styles.quiet : ""} ${className || ""}`}>
      <span className={styles.ring}></span>
      <span className={styles.ring}></span>
      {onClick ? (
        <button type="button" className={coreClasses} onClick={onClick} aria-label={label}>
          {children}
        </button>
      ) : (
        <span className={coreClasses}>{children}</span>
      )}
    </span>
  );
}
